<template>
  <div class="product-page">
    <!-- 模块一至八：整屏滚动渐入模块（按模块序号自上而下排列） -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <!-- 设计稿画布：固定1920×1080，随窗口尺寸与浏览器缩放等比缩放 -->
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <div class="section-inner">
          <!-- ============ 模块一：产品首屏 ============ -->
          <!-- 模块一背景图：独立 img 与独立类，可单独调整大小和位置；手机端切换为竖版 product-1-back-MOBILE.png -->
          <img v-if="item.key === 'hero'" :src="isMobile ? ($i18n.locale === 'en' ? require('../assets/images/product/product-1-back-INTMOBILE.png') : require('../assets/images/product/product-1-back-MOBILE.png')) : item.bgImage" class="section-bg-hero" />
          <!-- 模块一上层 wifi 图：仅桌面端显示加载，移动端不显示不加载 -->
          <img v-if="item.key === 'hero' && !isMobile" class="section-overlay-hero-wifi" src="../assets/images/product/product-1-wifi.png" alt="" />
          <!-- 模块一上层手机图：仅桌面端显示加载，移动端不显示不加载；英文版切换为 product-1-INTphone.png -->
          <img v-if="item.key === 'hero' && !isMobile" class="section-overlay-hero-phone" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-1-INTphone.png') : require('../assets/images/product/product-1-phone.png')" alt="" />
          <!-- 模块一左下角产品介绍文字（HTML 渲染，改 .hero-desc 可调位置样式） -->
          <div v-if="item.key === 'hero'" class="hero-desc">
            <div class="hero-title">{{ $t('product.heroTitle') }}</div>
            <div class="hero-subtitle">{{ $t('product.heroSubtitle') }}</div>
            <div class="hero-text">{{ mobileText($t('product.heroDesc')) }}</div>
          </div>
          <!-- ============ 模块二：产品特点（五个灰色背景块） ============ -->
          <!-- 五个灰色背景块统一包在居中容器内，整体水平居中，两侧留白恒相等 -->
          <div v-if="item.key === 'bluetooth'" class="feature-grid">
            <!-- 无痛佩戴区域（450×650，改 .painless-card 可调位置大小） -->
            <div class="painless-card">
              <div class="painless-title">{{ $t('product.painlessTitle') }}</div>
              <div class="painless-desc">{{ mobileText($t('product.painlessDesc')) }}</div>
              <img class="painless-img" src="../assets/images/product/product-2-girl.png" alt="无痛佩戴 更舒适" />
            </div>
            <!-- 蓝牙传输灰色背景块（330×310，上边与无痛佩戴背景块平齐） -->
            <div class="bluetooth-card">
              <div class="bluetooth-title">{{ $t('product.bluetoothTitle') }}</div>
              <div class="bluetooth-desc">{{ mobileText($t('product.bluetoothSubtitle')) }}</div>
              <img class="bluetooth-img" src="../assets/images/product/product-2-lanya.png" alt="蓝牙5.0传输" />
            </div>
            <!-- 无需校准灰色背景块（690×310，上边与无痛佩戴/蓝牙块平齐） -->
            <div class="calib-card">
              <div class="calib-title">{{ $t('product.calibTitle') }}</div>
              <div class="calib-desc">{{ mobileText($t('product.calibDesc')) }}</div>
              <img class="calib-img" src="../assets/images/product/product-2-waike.png" alt="无需校准 更方便" />
            </div>
            <!-- 小巧便携灰色背景块（690×310，第二行） -->
            <div class="compact-card">
              <div class="compact-title">{{ $t('product.compactTitle') }}</div>
              <div class="compact-desc">{{ mobileText($t('product.compactDesc')) }}</div>
              <img class="compact-img" src="../assets/images/product/product-2-xty.png" alt="小巧体积 佩戴便携" />
            </div>
            <!-- 数据报告灰色背景块（330×310，第二行与小巧便携块上边平齐） -->
            <div class="report-card">
              <div class="report-title">{{ $t('product.reportTitle') }}</div>
              <div class="report-desc">{{ mobileText($t('product.reportDesc')) }}</div>
              <img class="report-img" src="../assets/images/product/product-2-tu.png" alt="数据查看简单易懂" />
            </div>
          </div>
          <!-- ============ 模块三：应用场景（大标题+四个白色背景块） ============ -->
          <!-- 整体纵向居中（仅渲染文字，改 .scene-grid 可调白块区） -->
          <div v-if="item.key === 'compact'" class="block-content">
            <h2 class="section-title">{{ $t('product.sceneTitle') }}</h2>
            <div class="section-divider"></div>
            <p class="section-subtitle">{{ $t('product.sceneSubtitle') }}</p>
            <div class="scene-grid">
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneSport') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-swim.png" alt="运动" />
              </div>
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneShower') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-shawwer.png" alt="淋浴" />
              </div>
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneWork') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-work.png" alt="工作" />
              </div>
              <div class="scene-block">
                <div class="scene-block-title">{{ $t('product.sceneSleep') }}</div>
                <img class="scene-block-img" src="../assets/images/product/product-3-sleep.png" alt="睡眠" />
              </div>
            </div>
          </div>
          <!-- ============ 模块四：控糖打卡 ============ -->
          <div v-if="item.key === 'record'" class="block-content">
            <h2 class="section-title">{{ $t('product.recordTitle') }}</h2>
            <div class="section-divider"></div>
            <p class="section-subtitle">{{ $t('product.recordSubtitle') }}</p>
            <!-- 英文版切换为 ctrl-gluINT.png，中文保持原图；手机端不加载（isMobile 与 CSS 媒体查询同断点） -->
            <img v-if="!isMobile" class="block-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/ctrl-gluINT.png') : require('../assets/images/product/ctrl-glu.png')" alt="控糖打卡" />
            <!-- 英文版补充图：运动打卡表单截图，仅桌面端英文显示；位置大小见 CSS 中 .record-sport-img -->
            <img v-if="!isMobile && $i18n.locale === 'en'" class="record-sport-img" src="../assets/images/product/product-2-4-INT.png" alt="运动打卡" />
            <!-- 手机端专用图：替换上方两张图；英文版切换为 product-4-INTmobile.png，中文保持 product-4-mobile.png -->
            <img v-if="isMobile" class="record-mobile-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-4-INTmobile.png') : require('../assets/images/product/product-4-mobile.png')" alt="控糖打卡" />
          </div>
          <!-- ============ 模块五：AGP报告（顶部居中标题区+底部左文右图） ============ -->
          <div v-if="item.key === 'scene'" class="agp-layout">
            <!-- 模块五顶部：大标题+分割线+小标题，整体居中 -->
            <div class="agp-header">
              <h2 class="section-title">{{ $t('product.agpTitle') }}</h2>
              <div class="section-divider"></div>
              <p class="section-subtitle">{{ $t('product.agpSubtitle') }}</p>
            </div>
            <!-- 模块五底部：左侧正文容器，右侧AGP图 -->
            <div class="agp-body">
              <div class="agp-text">
                <!-- 正文容器：三段文字统一管理，改 .agp-point 的 margin-bottom 调段落间距 -->
                <div class="agp-points">
                  <div class="agp-point">
                    <img class="agp-point-icon" src="../assets/images/product/product-5-dian.png" alt="" />
                    <p class="agp-point-text">{{ $t('product.agpPoint1') }}</p>
                  </div>
                  <div class="agp-point">
                    <img class="agp-point-icon" src="../assets/images/product/product-5-dian.png" alt="" />
                    <p class="agp-point-text">{{ $t('product.agpPoint2') }}</p>
                  </div>
                  <div class="agp-point">
                    <img class="agp-point-icon" src="../assets/images/product/product-5-dian.png" alt="" />
                    <p class="agp-point-text">{{ $t('product.agpPoint3') }}</p>
                  </div>
                </div>
              </div>
              <!-- 模块五右侧：AGP图谱（改 .agp-img 可调大小位置）；英文版切换为 product-5-INTAGP.png -->
              <img class="agp-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-5-INTAGP.png') : require('../assets/images/product/product-5-AGP.png')" alt="AGP报告" />
            </div>
          </div>
          <!-- ============ 模块六：血糖分析周期回顾（顶部居中标题区+底部左图右文） ============ -->
          <div v-if="item.key === 'analysis'" class="analysis-layout">
            <!-- 模块六顶部：大标题+分割线+小标题，整体居中 -->
            <div class="analysis-header">
              <h2 class="section-title">{{ $t('product.analysisTitle') }}</h2>
              <div class="section-divider"></div>
              <p class="section-subtitle">{{ $t('product.analysisSubtitle') }}</p>
            </div>
            <!-- 模块六底部：左侧报告图，右侧专家级血糖报告 -->
            <div class="analysis-body">
              <!-- 左侧：报告截图；英文版切换为 product-6-INTreport.png -->
              <img class="analysis-report-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-6-INTreport.png') : require('../assets/images/product/product-6-report.png')" alt="周期血糖报告" />
              <!-- 右侧：专家级血糖报告 -->
              <div class="analysis-text">
                <h3 class="analysis-expert-title">{{ $t('product.expertTitle') }}</h3>
                <ul class="analysis-points">
                  <li class="analysis-point">{{ $t('product.expertPoint1') }}</li>
                  <li class="analysis-point">{{ $t('product.expertPoint2') }}</li>
                </ul>
              </div>
            </div>
            <!-- 模块六右下角：血糖图；英文版切换为 product-6-INTglu.png -->
            <img class="analysis-glu-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-6-INTglu.png') : require('../assets/images/product/product-6-glu.png')" alt="血糖图表" />
          </div>
          <!-- ============ 模块七：三大模式（顶部居中标题区+底部三白块） ============ -->
          <div v-if="item.key === 'model'" class="model-layout">
            <!-- 模块七顶部：大标题+分割线+小标题，整体居中 -->
            <div class="model-header">
              <h2 class="section-title">{{ $t('product.modelTitle') }}</h2>
              <div class="section-divider"></div>
              <p class="section-subtitle">{{ $t('product.modelSubtitle') }}</p>
            </div>
            <!-- 模块七底部：三个模式卡片 -->
            <div class="model-cards">
              <div class="model-card">
                <!-- 专业模式图；英文版切换为 product-7-INTzhuanye.png -->
                <img class="model-card-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-7-INTzhuanye.png') : require('../assets/images/product/product-7-zhuanye.png')" alt="专业模式" />
                <!-- 悬停遮罩层 -->
                <div class="model-card-overlay">
                  <h3 class="overlay-title">{{ $t('product.modePro') }}</h3>
                  <p class="overlay-desc">{{ $t('product.modeProDesc') }}</p>
                </div>
              </div>
              <div class="model-card">
                <!-- 亲友模式图；英文版切换为 product-7-INTqinyou.png -->
                <img class="model-card-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-7-INTqinyou.png') : require('../assets/images/product/product-7-qinyou.png')" alt="亲友模式" />
                <!-- 悬停遮罩层 -->
                <div class="model-card-overlay">
                  <h3 class="overlay-title">{{ $t('product.modeFamily') }}</h3>
                  <p class="overlay-desc">{{ $t('product.modeFamilyDesc') }}</p>
                </div>
              </div>
              <div class="model-card">
                <!-- 关怀模式图；英文版切换为 product-7-INTguanhuai.png -->
                <img class="model-card-img" :src="$i18n.locale === 'en' ? require('../assets/images/product/product-7-INTguanhuai.png') : require('../assets/images/product/product-7-guanhuai.png')" alt="关怀模式" />
                <!-- 悬停遮罩层 -->
                <div class="model-card-overlay">
                  <h3 class="overlay-title">{{ $t('product.modeCare') }}</h3>
                  <p class="overlay-desc">{{ $t('product.modeCareDesc') }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- ============ 模块八：官方商城 ============ -->
          <div v-if="item.key === 'shop'" class="block-content">
            <h2 class="section-title">{{ $t('product.officialShop') }}</h2>
            <div class="shop-links">
              <a href="https://cofoe.tmall.com/shop/view_shop.htm?ali_refid=a3_430582_1006:1124015931:H:bYEbOfJPdCHDafE2c8exZA%3D%3D:15fb641df49f28679c01fe1336358bdb&ali_trackid=282_15fb641df49f28679c01fe1336358bdb&spm=a21n57.1.1.1&pisk=gootLK1UmBAgjvxBwGYHnChSNDpHBeDwsfk5mSVGlXhKhWjDQlY4DjFKg54gf5jYDxhqijH2Q-NjGjFmSexoQAr4cQcvq3DZpTeAwfUffw9bERe6KP1tClW_cQAkDwXQ7CqjIgwrrW_QUWw1fPZXpyw4F1ZblRMBp-wc1ZssGv9LT8W1coajdwwzhoNjGo9KdWybcRGbcpHQT-G5hIFCCSjxJQunpQ7i9isjvRUB-ANCKonQBWN-CcIfctyTW7M_OCUp7C4I3rnV3iUxC4l4Ff16MSoKdcgSNBbg14exEqH6fMZibAg7l0OVlArg6kisytsjplFjZRzR6BFSbvizAyxWeviEsAoKnttbKbVIQcZvVLrTf5ZLLmAFfS3Ilc4a01OYgDHIfqIr20m8uE1uw-b6ppQVuPwUiS653tgHR7wLZdKAuZzeLJFkppQVuPwUp7v9HZ748p5..&mm_sceneid=1_0_112774535_0" target="_blank" class="shop-link">
                <img src="../assets/images/product/tmall.png" alt="天猫" />
                <span>{{ $t('product.shopTmall') }}</span>
              </a>
              <a href="https://mall.jd.com/index-1000329903.html?from=pc" target="_blank" class="shop-link">
                <img src="../assets/images/product/jd.png" alt="京东" />
                <span>{{ $t('product.shopJd') }}</span>
              </a>
              <a href="https://www.pinduoduo.com/home/app/" target="_blank" class="shop-link">
                <img src="../assets/images/product/pdd.png" alt="拼多多" />
                <span>{{ $t('product.shopPdd') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'ProductPage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      // 八大模块：按模块序号自上而下排列
      sections: [
        { key: 'hero', className: 'module-hero', bgImage: require('@/assets/images/product/product-1-back.png') }, // 模块一：产品首屏
        { key: 'bluetooth', className: 'module-bluetooth' }, // 模块二：产品特点
        { key: 'compact', className: 'module-compact' }, // 模块三：应用场景
        { key: 'record', className: 'module-record' }, // 模块四：控糖打卡
        { key: 'scene', className: 'module-scene' },   // 模块五：AGP报告
        { key: 'analysis', className: 'module-analysis' }, // 模块六：血糖分析周期回顾
        { key: 'model', className: 'module-model' },   // 模块七：产品型号
        { key: 'shop', className: 'module-shop' }      // 模块八：官方商城
      ],
      visibleMap: {},
      observer: null,
      isMobile: false,
      mobileQuery: null
    }
  },
  computed: {
    // 模块一是否可见，用于控制导航栏透明效果
    heroVisible() {
      return !!this.visibleMap[0]
    }
  },
  watch: {
    // 仅产品页模块一可见时导航栏透明，滚到其他模块恢复白底
    heroVisible(val) {
      const header = document.querySelector('.header')
      if (header) {
        header.classList.toggle('header-transparent', val)
      }
    }
  },
  mounted() {
    // 滚动吸附由 App.vue 按断点统一管理；记录初始浏览器缩放基准，
    // 后续 Ctrl +/- 缩放时据此补偿，避免缩放被视口变化抵消
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    // 断点监听：模块一背景图手机端切换竖版图（与 CSS 媒体查询断点保持一致）
    this.mobileQuery = window.matchMedia('(max-width: 1024px)')
    this.isMobile = this.mobileQuery.matches
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.onMobileChange)
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(this.onMobileChange)
    }
    this.initObserver()
    // 页脚链接带 ?to= 参数进入时，滚到对应模块（如 ?to=shop 定位模块八官方商城）
    this.scrollToQueryModule()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    // 离开产品页时清除导航栏透明态
    const header = document.querySelector('.header')
    if (header) {
      header.classList.remove('header-transparent')
    }
    if (this.mobileQuery) {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onMobileChange)
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onMobileChange)
      }
    }
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    onMobileChange(e) {
      this.isMobile = e.matches
    },
    mobileText(text) {
      // 文案换行标记约定：\n = 桌面排版换行，| = 手机端专用换行（可逐条单独控制）
      // 手机端：去掉 \n、把 | 变真换行（配合 white-space: pre-line）；桌面：去掉 |（\n 原样保留）
      return this.isMobile
        ? String(text).replace(/\n/g, '').replace(/\|/g, '\n')
        : String(text).replace(/\|/g, '')
    },
    // 页脚锚点 → 模块选择器映射；新增页脚直达模块时在此补充
    scrollToQueryModule() {
      const moduleMap = { shop: '.module-shop' }
      const selector = moduleMap[this.$route.query.to]
      if (!selector) {
        return
      }
      this.$nextTick(() => {
        const el = this.$el.querySelector(selector)
        if (el) {
          el.scrollIntoView()
        }
      })
    },
    updateScale() {
      // 按视口与1920×1080设计稿的比例取较大值（cover模式），
      // 保证画布始终铺满窗口不留白，非16:9窗口时边缘居中裁切
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      // 浏览器 Ctrl +/- 缩放会同步改变视口尺寸（等比抵消），
      // 通过 devicePixelRatio 计算当前缩放倍数并补偿，使内容随浏览器缩放同步变大变小
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        // 不支持 IntersectionObserver 时直接全部显示
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    }
  }
}
</script>

<style scoped>

/* 全屏高度纵向模块，配合页面级 scroll-snap 实现整屏吸附切页 */
.fullscreen-section {
  height: 100vh;
  /* 手机端用 JS 实时写入的可见高度（App.vue），避免 100vh 高于可见区导致底部裁切；桌面不受影响 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
  background: #FFFFFF;
}

/* 设计稿画布：八个模块共用的固定尺寸容器，整体等比缩放 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入动效：初始透明并轻微下移；隐藏态不设过渡，离开视口瞬间重置，
     保证每次切页切回来都完整重播渐入（含各卡片/文字的独立动效） */
  opacity: 0;
  transform: translateY(48px);
  will-change: opacity, transform;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 背景图：默认铺满画布，裁切时以画面中心为视觉焦点 */
.section-bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

/* 通用内容块：标题+分割线+副标题+主图，纵向居中（模块三/五/六/七/八共用） */
.block-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
}

/* 通用标题区分割线 */
.section-divider {
  width: 400px;
  height: 1px;
  background-color: #000000;
  margin: 0 auto 24px;
}

/* 通用标题区副标题 */
.section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 30px;
  color: #000000;
  margin: 0 0 30px 0;
}

/* 通用内容主图 */
.block-img {
  max-width: 85%;
  max-height: 600px;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* ============================================================
 * 模块一：产品首屏（样式集中在此处维护）
 * ============================================================ */

/* 模块一背景图：独立控制，可自行调整 width/height/object-position 等 */
/* top 对齐画布顶端，使图片延伸到透明导航栏后面 */
.section-bg-hero {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

/* 模块一：上层wifi图，独立控制位置与大小（默认居中，改 top/left/width 即可移动） */
.section-overlay-hero-wifi {
  position: absolute;
  top: 45.7%;
  left: 54%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: auto;
  object-fit: contain;
  z-index: 10;
}

/* 模块一：上层手机图，独立控制位置与大小（改 top/left/width 即可移动） */
.section-overlay-hero-phone {
  position: absolute;
  top: 53%;
  left: 73%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: auto;
  object-fit: contain;
  z-index: 10;
}

/* 模块一：左下角产品介绍文字，独立控制位置与样式 */
.hero-desc {
  position: absolute;
  top: 50%;
  left: 15%;
  width: 42%;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 28px;
  line-height: 1.9;
  color: #FFFFFF;
  text-align: left;
  z-index: 10;
}

/* 模块一：产品主标题（可孚孚探®） */
.hero-desc .hero-title {
  font-size: 40px;
  font-weight: 550;
  line-height: 1.6;
  margin-bottom: 8px;
}

/* 模块一：产品副标题（持续葡萄糖监测系统） */
.hero-desc .hero-subtitle {
  font-size: 52px;
  font-weight: 550;
  line-height: 1.2;
  margin-bottom: 28px;
}

/* 模块一：产品介绍正文（pre-line保留文案中的\n换行） */
.hero-desc .hero-text {
  font-size: 24px;
  font-weight: 200;
  line-height: 1.5;
  white-space: pre-line;
  opacity: 0.6;
}

/* 仅英文生效：模块一文字大小单独调节 + 每个单词首字母大写 */
:lang(en) .hero-desc .hero-title {      /* 主标题："Cofoe®" */
  font-size: 40px;
}

:lang(en) .hero-desc .hero-subtitle {   /* 副标题："Continuous Glucose..." */
  font-size: 40px;
}

:lang(en) .hero-desc .hero-text {
  font-size: 24px;
  text-transform: capitalize;
  text-align: justify;
}

/* ------------------------------------------------------------
 * 模块一动效独立拆分：两个标题（主标题+副标题）一组，介绍正文一组，互不影响，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播。
 * 每组调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，改 translateY(24px) 调上移幅度。
 * ------------------------------------------------------------ */

/* 第1组：两个标题（.hero-title + .hero-subtitle），延迟 0s */
.reveal-section .hero-desc .hero-title,
.reveal-section .hero-desc .hero-subtitle {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .hero-desc .hero-title,
.reveal-section.is-visible .hero-desc .hero-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.1s,
    transform 0.8s ease 0s;
}

/* 第2组：介绍正文（.hero-text），延迟 0.2s 错开入场 */
.reveal-section .hero-desc .hero-text {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .hero-desc .hero-text {
  opacity: 0.6;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.3s,
    transform 0.8s ease 0.2s;
}

/* ============================================================
 * 模块二：产品特点（五个灰色背景块，样式集中在此处维护）
 * ============================================================ */

/* 模块二：五个背景块的居中容器，宽为整组内容（1530px），水平居中保证两侧留白恒相等 */
/* 若需整体左右微调，改 left 的 calc 偏移即可，如 calc(50% + 20px) */
.feature-grid {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1530px;
  height: 100%;
  z-index: 10;
}

/* 模块二：无痛佩戴灰色背景块，450×650，独立控制位置与大小（改 top/left/width/height 即可） */
.painless-card {
  position: absolute;
  top: 24%;
  left: 0;
  width: 450px;
  height: 650px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  overflow: hidden;
  z-index: 10;
}

/* 模块二：无痛佩戴标题（pre-line保留文案中的\n换行） */
.painless-card .painless-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

/* 模块二：无痛佩戴描述 */
.painless-card .painless-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 模块二：无痛佩戴人物图，底部居中铺在灰块内，超出部分裁切（改 width/left/bottom 可调）；z-index:-1 压在文字下层 */
.painless-card .painless-img {
  position: absolute;
  left: 70%;
  bottom: 0;
  transform: translateX(-50%);
  width: 60%;
  height: auto;
  object-fit: contain;
  z-index: -1;
}

/* 模块二：蓝牙传输灰色背景块，330×310，top与无痛佩戴块一致保证上边平齐（改 top/left/width/height 即可） */
.bluetooth-card {
  position: absolute;
  top: 24%;
  left: 480px;
  width: 330px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

/* 模块二：蓝牙传输标题（pre-line保留文案中的\n换行） */
.bluetooth-card .bluetooth-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

/* 模块二：蓝牙传输描述（pre-line保留文案中的\n换行） */
.bluetooth-card .bluetooth-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 模块二：蓝牙图标，文字下方居中，可向下超出灰块（改 top/left/width 可调）；z-index:-1 压在文字下层 */
.bluetooth-card .bluetooth-img {
  position: absolute;
  top: 45%;
  left: 73%;
  transform: translateX(-50%);
  width: 48%;
  height: auto;
  object-fit: contain;
  z-index: -1;
}

/* 模块二：无需校准灰色背景块，690×310，top与其他两块一致保证上边平齐（改 top/left/width/height 即可） */
.calib-card {
  position: absolute;
  top: 24%;
  left: 840px;
  width: 690px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

/* 模块二：无需校准标题（pre-line保留文案中的\n换行） */
.calib-card .calib-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

/* 模块二：无需校准描述（pre-line保留文案中的\n换行） */
.calib-card .calib-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 模块二：无需校准产品图，右侧垂直居中（改 top/right/height 可调）；z-index:-1 压在文字下层 */
.calib-card .calib-img {
  position: absolute;
  top: 65%;
  right: 20%;
  transform: translateY(-50%);
  height: 110%;
  width: auto;
  object-fit: contain;
  z-index: -1;
}

/* 模块二：小巧便携灰色背景块，690×310，第二行与同行块上边平齐（改 top/left/width/height 即可） */
.compact-card {
  position: absolute;
  top: 55.5%;
  left: 480px;
  width: 690px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

/* 模块二：小巧便携标题（pre-line保留文案中的\n换行） */
.compact-card .compact-title {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
  margin-bottom: 10px;
  white-space: pre-line;
}

/* 模块二：小巧便携描述（pre-line保留文案中的\n换行） */
.compact-card .compact-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4;
  white-space: pre-line;
}

/* 模块二：小巧便携产品图，右侧垂直居中（改 top/right/height 可调）；z-index:-1 压在文字下层 */
.compact-card .compact-img {
  position: absolute;
  top: 55%;
  right: 8%;
  transform: translateY(-50%);
  height: 100%;
  width: auto;
  object-fit: contain;
  z-index: -1;
}

/* 模块二：数据报告灰色背景块，330×310，top与小巧便携块一致保证上边平齐（改 top/left/width/height 即可） */
.report-card {
  position: absolute;
  top: 55.5%;
  left: 1200px;
  width: 330px;
  height: 310px;
  background: #F5F5F5;
  box-sizing: border-box;
  padding: 30px 28px 0;
  z-index: 10;
}

/* 模块二：数据报告标题（块较窄，字号略小保证单行；pre-line保留文案中的\n换行） */
.report-card .report-title {
  font-size: 24px   ;
  font-weight: 500;
  color: #000000;
  line-height: 1.0;
  margin-bottom: 10px;
  white-space: pre-line;
}

/* 模块二：数据报告描述（pre-line保留文案中的\n换行） */
.report-card .report-desc {
  font-size: 18px;
  font-weight: 300;
  color: #666666;
  line-height: 1.4 ;
  white-space: pre-line;
}

/* 模块二：数据报告图谱图，文字下方居中，可向下超出灰块（改 top/left/width 可调）；z-index:-1 压在文字下层 */
.report-card .report-img {
  position: absolute;
  top: 38%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: auto;
  object-fit: contain;
  z-index: -1;
}

/* ------------------------------------------------------------
 * 模块二：英文字号单独调入口（:lang(en) 规则，中文不受影响）
 * 只改对应规则里的 font-size 数值即可，无需动 i18n 文案
 * ------------------------------------------------------------ */

:lang(en) .painless-card .painless-title {   /* 无痛佩戴标题 */
  font-size: 24px;
}

:lang(en) .painless-card .painless-desc {    /* 无痛佩戴描述 */
  font-size: 18px;
}

:lang(en) .bluetooth-card .bluetooth-title { /* 蓝牙传输标题 */
  font-size: 24px;
}

:lang(en) .bluetooth-card .bluetooth-desc {  /* 蓝牙传输描述 */
  font-size: 18px;
}

:lang(en) .calib-card .calib-title {         /* 无需校准标题 */
  font-size: 24px;
}

:lang(en) .calib-card .calib-desc {          /* 无需校准描述 */
  font-size: 18px;
}

:lang(en) .compact-card .compact-title {     /* 小巧便携标题 */
  font-size: 24px;
}

:lang(en) .compact-card .compact-desc {      /* 小巧便携描述 */
  font-size: 18px;
}

:lang(en) .report-card .report-title {       /* 数据报告标题 */
  font-size: 24px;
}

:lang(en) .report-card .report-desc {        /* 数据报告描述 */
  font-size: 18px;
}

/* ------------------------------------------------------------
 * 模块二动效独立拆分：五个灰色背景块各自为一个动效（灰块连带块内文字与图一起动），
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播
 * 每块调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现（默认按顺序错开 0.1s），
 * 改 translateY(24px) 调上移幅度
 * ------------------------------------------------------------ */

/* 第1块：无痛佩戴（.painless-card） */
.reveal-section .painless-card {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .painless-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 第2块：蓝牙传输（.bluetooth-card） */
.reveal-section .bluetooth-card {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .bluetooth-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.1s,
    transform 0.8s ease 0.1s;
}

/* 第3块：无需校准（.calib-card） */
.reveal-section .calib-card {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .calib-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第4块：小巧便携（.compact-card） */
.reveal-section .compact-card {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .compact-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.3s,
    transform 0.8s ease 0.3s;
}

/* 第5块：数据报告（.report-card） */
.reveal-section .report-card {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .report-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.4s;
}

/* ============================================================
 * 模块三：应用场景（样式集中在此处维护）
 * ============================================================ */

/* 模块三背景：浅灰 */
.module-compact {
  background: #F5F5F5;
}

/* 模块三：大标题 */
.module-compact .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.6;
  margin: 20px 0 10px 0;
}

/* 模块三：小标题 */
.module-compact .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #B3B3B3;
  margin: 0 0 30px 0;
}

/* 模块三：四个白色背景块容器，水平居中随标题区纵向排布（改 gap 调白块间距） */
.scene-grid {
  display: flex;
  gap: 60px;
  margin-top: 20px;
}

/* 模块三：单个白色背景块，330×498，24px圆角，纵向布局标题在上图片在下（改 width/height/border-radius 可调） */
.scene-grid .scene-block {
  display: flex;
  flex-direction: column;
  width: 330px;
  height: 498px;
  background: #FFFFFF;
  border-radius: 24px;
  box-sizing: border-box;
  padding: 16px 16px 0 0;
}

/* 模块三：白块内场景图，标题下方居中，保持原始比例（改 width/margin-top 可调大小与间距，改 translateX 可左右微调） */
.scene-grid .scene-block-img {
  width: 90%;
  height: auto;
  object-fit: contain;
  margin: 30px auto 0;
  transform: translateX(8px);
}

/* 模块三：白块标题 */
.scene-grid .scene-block-title {
  font-size: 26px;
  font-weight: 400;
  margin-top: 10px;      /* 标题下移 10px，改这个数值即可 */
  margin-left: -200px;   /* 只动标题，不影响白块内边距 */
  color: #000000;
  line-height: 1.2;
}

/* ------------------------------------------------------------
 * 模块三动效独立拆分：四个白色背景块各自为一个动效（白块连带块内标题与图一起动），
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播
 * 每块调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现（默认按顺序错开 0.1s），
 * 改 translateY(24px) 调上移幅度
 * ------------------------------------------------------------ */

.reveal-section .scene-grid .scene-block {
  opacity: 0;
  transform: translateY(60px);
}

.reveal-section.is-visible .scene-grid .scene-block {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.1s,
    transform 0.8s ease 0.1s;
}

/* 第1块：运动，延迟 0.1s（上方默认规则）；以下依次错开 0.2s */
.reveal-section.is-visible .scene-grid .scene-block:nth-child(2) {
  transition-delay: 0.2s;   /* 第2块：淋浴 */
}

.reveal-section.is-visible .scene-grid .scene-block:nth-child(3) {
  transition-delay: 0.3s;   /* 第3块：工作 */
}

.reveal-section.is-visible .scene-grid .scene-block:nth-child(4) {
  transition-delay: 0.4s;   /* 第4块：睡眠 */
}

/* ============================================================
 * 模块四：控糖打卡（样式集中在此处维护）
 * ============================================================ */

/* 模块四背景：白色 */
.module-record {
  background: #FFFFFF;
}

/* 模块四：大标题 */
.module-record .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 70px 0 20px 0;
}

/* 模块四：小标题 */
.module-record .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #B3B3B3;
  margin: 0 0 10px 0;
}

/* 模块四：插图 */
.module-record .block-img {
  height: 620px;
  width: auto;
  object-fit: contain;
}

/* 模块四：英文版补充插图（运动打卡表单截图），仅英文显示（模板中 v-if 控制） */
/* 绝对定位于画布（1920×1080），改 top/left 调位置，改 width 调大小；z-index 盖在主图上方 */
.module-record .record-sport-img {
  position: absolute;
  top: 650px;
  left: 660px;
  width: 300px;
  height: auto;
  object-fit: contain;
  z-index: 11;
}

/* ------------------------------------------------------------
 * 模块四动效独立拆分：标题区（大标题+分割线+小标题）一组，主图一个动效，英文补充图一个动效，
 * 互不影响；透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播。
 * 每组调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，改 translateY(24px) 调上移幅度。
 * ------------------------------------------------------------ */

/* 第1组：标题区（.section-title + .section-divider + .section-subtitle），延迟 0s */
.module-record .section-title,
.module-record .section-divider,
.module-record .section-subtitle {
  opacity: 0;
  transform: translateY(24px);
}

.module-record.is-visible .section-title,
.module-record.is-visible .section-divider,
.module-record.is-visible .section-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.1s,
    transform 0.8s ease 0.1s;
}

/* 第2组：主图（控糖打卡截图 .block-img），延迟 0.2s 错开入场 */
.module-record .block-img {
  opacity: 0;
  transform: translateY(48px);
}

.module-record.is-visible .block-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第3组：英文补充图（运动打卡表单 .record-sport-img，仅英文渲染）*/
.module-record .record-sport-img {
  opacity: 0;
  transform: translateY(48px);
}

.module-record.is-visible .record-sport-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* ============================================================
 * 模块五：AGP报告（左文右图，样式集中在此处维护）
 * ============================================================ */

/* 模块五背景：浅灰 */
.module-scene {
  background: #F5F5F5;
}

/* 模块五：整体布局，顶部标题区居中+底部左文右图（按设计稿位置） */
.module-scene .agp-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 160px; /* 顶部留白（避开导航栏），改这个数值调标题区上下位置 */
}

/* 模块五：顶部标题区（大标题+分割线+小标题，居中） */
.module-scene .agp-header {
  text-align: center;
}

/* 模块五：大标题（加粗黑字，居中） */
.module-scene .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 40px;
  color: #000000;
  line-height: 1.2;
  margin: 80px 0 24px 0;
}

/* 模块五：小标题（居中，灰色，分割线用全局 .section-divider） */
.module-scene .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #8C8C8C;
  margin: 0 0 40px 0;
}

/* 模块五：底部左文右图区（改 gap 调文字与图的左右间距） */
.module-scene .agp-body {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: -40px;
}

/* 模块五：左侧文字区（改 width 调文字区宽窄，影响正文换行位置） */
.module-scene .agp-text {
  width: 950px;
  text-align: left;
}

/* 模块五：正文容器，三段文字统一管理 */
.module-scene .agp-points {
  margin: 0 20px 0 50px;
}

/* 模块五：每个正文条目（图标 + 文字，横向排列） */
.module-scene .agp-point {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 60px;
}

.module-scene .agp-point:last-child {
  margin-bottom: 20px;
}

/* 模块五：正文前的图标（改 width/height 调大小） */
.module-scene .agp-point-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-top: 4px;
}

/* 模块五：正文文字（改 line-height 调行距，改 font-size 调字号） */
.module-scene .agp-point-text {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  line-height: 1.8;
  white-space: pre-line;
  margin: 0;
}

/* 模块五：右侧AGP图谱（独立控制，改 height 调大小，改 margin/transform 微调位置） */
.module-scene .agp-img {
  height: 520px;
  width: auto;
  object-fit: contain;
  transform: translate(80px, 10px);
}

/* ------------------------------------------------------------
 * 模块五动效独立拆分：三行介绍文字（.agp-point）一行一个动效，AGP图（.agp-img）一个动效，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播
 * 调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现（三行默认依次错开 0.15s），
 * 改 translateY(24px) 调上移幅度
 * ------------------------------------------------------------ */

/* 三行文字共用一组规则，延迟用 :nth-child 分别覆盖（第1行默认 0s） */
.reveal-section .agp-points .agp-point {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .agp-points .agp-point {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0s;
}

.reveal-section.is-visible .agp-points .agp-point:nth-child(2) {
  transition-delay: 0.4s;   /* 第2行 */
}

.reveal-section.is-visible .agp-points .agp-point:nth-child(3) {
  transition-delay: 0.6s;    /* 第3行 */
}

/* AGP图入场——渐入上移；注：图自带 translate(80px, 10px) 位置微调，动效位移需叠在其后 */
.module-scene .agp-img {
  opacity: 0;
  transform: translate(80px, 10px) translateY(24px);
}

.module-scene.is-visible .agp-img {
  opacity: 1;
  transform: translate(80px, 10px);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* ============================================================
 * 模块六：血糖分析周期回顾（样式集中在此处维护）
 * ============================================================ */

/* 模块六背景：白色 */
.module-analysis {
  background: #FFFFFF;
}

/* 模块六整体布局 */
.module-analysis .analysis-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 220px;
}

/* 模块六：顶部标题区（大标题+分割线+小标题，居中）；z-index 抬高，避免小标题被右下角血糖图遮挡 */
.module-analysis .analysis-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

/* 模块六：大标题 */
.module-analysis .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 0 0 20px 0;
}

/* 模块六：小标题 */
.module-analysis .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #B3B3B3;
  margin: 0 0 0 30px;
}

/* 仅英文生效：模块六小标题（font-size 调字号；translate 调位置，不影响占位，图片等其他元素不会跟着动） */
:lang(en) .module-analysis .section-subtitle {
  font-size: 30px;
  transform: translate(0, -10px);
}

/* 模块六：底部左图右文区 */
.module-analysis .analysis-body {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  width: 100%;
}

/* 模块六：左侧报告图 */
.module-analysis .analysis-report-img {
  height: 730px;
  width: auto;
  object-fit: contain;
  transform: translate(-110px, -95px);
}

/* 模块六：右侧文字区 */
.module-analysis .analysis-text {
  width: 600px;
  text-align: left;
  transform: translate(-70px, -60px);
}

/* 模块六：专家级血糖报告标题 */
.module-analysis .analysis-expert-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 450;
  font-size: 36px;
  color: #000000;
  margin: 0 0 30px 0;
  transform: translate(-40px, -100px);
}

/* 模块六：正文列表 */
.module-analysis .analysis-points {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  transform: translate(-30px, -100px);
}

.module-analysis .analysis-point {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 20px;
  color: #B3B3B3;
  line-height: 1.4;
  margin: 0 0 16px 0;
  position: relative;
  padding-left: 20px;
}

.module-analysis .analysis-point::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #CCCCCC;
}

/* 仅英文生效：模块六两条正文每个单词首字母大写，删除此规则即恢复原样式 */
:lang(en) .module-analysis .analysis-point {
  text-transform: capitalize;
}

/* 模块六：右下角血糖图（独立控制，改 width/height 调大小，改 right/bottom/transform 调位置）；z-index:1 压在标题区下方 */
.module-analysis .analysis-glu-img {
  position: absolute;
  right: 30px;
  bottom: 130px;
  width: 980px;
  height: auto;
  object-fit: contain;
  z-index: 1;
}

/* ------------------------------------------------------------
 * 模块六动效独立拆分：两张图各自为一个动效，互不影响，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播，
 * 隐藏态保留各自布局 translate 基准，动画位移叠加在其后，不改变最终位置。
 * 每张图调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，
 * 改 translateY(24px) 调上移幅度
 * ------------------------------------------------------------ */

/* 图1：左侧报告图（.analysis-report-img），延迟 0s */
.reveal-section .analysis-report-img {
  opacity: 0;
  transform: translate(-110px, -95px) translateX(-60px);
}

.reveal-section.is-visible .analysis-report-img {
  opacity: 1;
  transform: translate(-110px, -95px) translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 图2：右下角血糖图（.analysis-glu-img），延迟 0.2s 错开入场 */
.reveal-section .analysis-glu-img {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .analysis-glu-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}


/* ============================================================
 * 模块七：三大模式（样式集中在此处维护）
 * ============================================================ */

/* 模块七背景：浅灰（与模块五一致） */
.module-model {
  background: #F5F5F5;
}

/* 模块七整体布局 */
.module-model .model-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 220px;
}

/* 模块七：顶部标题区（大标题+分割线+小标题，居中） */
.module-model .model-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 模块七：大标题 */
.module-model .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 0 0 20px 0;
}

/* 模块七：小标题 */
.module-model .section-subtitle {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 30px;
  color: #B3B3B3;
  margin: 0 0 50px 0;
}

/* 模块七：三个白色模式卡片容器 */
.module-model .model-cards {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
}

/* 模块七：单个白色模式卡片 */
.module-model .model-card {
  width: 320px;
  height: 560px;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

/* 模块七：卡片内图片（独立控制，改 width 调大小，改 margin/transform 微调位置） */
.module-model .model-card-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  margin-top: 0;
  transition: filter 0.3s ease;
}

/* 模块七：悬停遮罩层（默认隐藏，鼠标悬停时显示） */
.module-model .model-card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 24px;
  box-sizing: border-box;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 10;
}

.module-model .model-card:hover .model-card-overlay {
  opacity: 1;
}

.module-model .model-card:hover .model-card-img {
  filter: blur(6px);
}

/* 模块七：遮罩层标题 */
.module-model .overlay-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 550;
  font-size: 24px;
  color: #FFFFFF;
  margin: 0 0 16px 0;
}

/* 模块七：遮罩层标题下方横线（改 width 调线长，改 background-color 调颜色，
   改 margin-top 调标题与线的间距，改 height 调线粗） */
.module-model .overlay-title::after {
  content: '';
  display: block;
  width: 96px;
  height: 1px;
  background-color: #FFFFFF;
  margin-top: 10px;
}

/* 模块七：遮罩层描述文字 */
.module-model .overlay-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 1.8;
  margin: 0;
  text-align: left;
}

/* ------------------------------------------------------------
 * 模块七动效独立拆分：三张模式图各自为一个动效，从左到右依次入场，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播。
 * 改 translateY(24px) 调上移幅度；可见态需保留 filter 过渡，否则悬停模糊失效。
 * ------------------------------------------------------------ */

.reveal-section .model-card-img {
  opacity: 0;
  transform: translateY(24px);
}

/* 第1张：专业模式，延迟 0s */
.reveal-section.is-visible .model-cards .model-card:nth-child(1) .model-card-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0s,
    filter 0.3s ease;
}

/* 第2张：亲友模式 */
.reveal-section.is-visible .model-cards .model-card:nth-child(2) .model-card-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.1s,
    filter 0.3s ease;
}

/* 第3张：关怀模式 */
.reveal-section.is-visible .model-cards .model-card:nth-child(3) .model-card-img {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s,
    filter 0.3s ease;
}

/* ============================================================
 * 模块八：官方商城（样式集中在此处维护）
 * ============================================================ */

/* 模块八背景：白色 */
.module-shop {
  background: #FFFFFF;
}

/* 仅英文生效：隐藏模块八（官方商城）整个整屏区块，
   切回中文自动恢复；删除此规则即可取消隐藏 */
:lang(en) .module-shop {
  display: none;
}

/* 模块八：大标题（改 font-size 调大小，改 top 调位置） */
.module-shop .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 50px;
  color: #000000;
  line-height: 1.2;
  position: relative;
  top: -140px;
}

/* 模块八：三个商城入口 */
.shop-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 240px;
  position: relative;
  top: 10px;
}

.shop-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-decoration: none;
}

.shop-link img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

/* 商城入口缩放特效 */
.shop-link:hover img {
  transform: scale(1.15);
}
/* 商城入口文字 */
.shop-link span {
  font-size: 20px;
  color: #666;
}

/* 商城入口文字后缀箭头 */
.shop-link span::after {
  content: ' ›';
  color: #00ADBB;
  font-size: 30px;
}

/* ============================================================
 * 页脚独立吸附
 * ============================================================ */

/* 页脚高度不足一屏，底部对齐吸附，保证最后一屏完整展示 */
.product-page >>> .footer {
  scroll-snap-align: end;
}







/* ============================================================
 * 移动端适配（<= 1024px）：统一文档流方案，禁用画布缩放，
 * !important 覆盖行内 transform（JS 缩放值）；
 * 统一规范：模块布局一律用文档流（flex column 容器 + order 排序 + position: static 图片），
 * 间距 margin 一律用 vh（按约 700px 屏高换算：8px≈1vh、12~16px≈2vh、20px≈3vh、24~28px≈4vh、60px≈8vh），
 * 容器顶对齐 justify-content: flex-start + padding-top 预留固定导航栏（高 60px，预留值用 px），
 * 文字留白用 % padding，图片高度用 max-height: vh 兜底，
 * 字号统一用 vw（375px 屏宽基准：16px≈4.27vw），保证各手机每行字数与换行一致
 * ============================================================ */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* 全部流式项禁止被 flex 压缩：内容总高超出整屏时，
     细元素（1px 分割线等）会被默认收缩直接压成 0 而消失，
     超出部分应落到底部裁切区而不是压缩内容 */
  .product-page .section-inner * {
    flex-shrink: 0;
  }

  /* 通用内容块（模块三/四/八共用）：垂直居中改顶对齐 + padding-top 预留固定导航栏，
     内容超高时溢出只发生在底部，不会裁掉顶部标题 */
  .block-content {
    justify-content: flex-start;
    padding-top: 76px;
  }

  /* ---------- 模块一：产品首屏 ---------- */

  /* 内容容器改 flex 纵向文档流：子元素顺序用 order 控制，间距用 vh margin 控制，
     不再依赖 top/left 定位（仅媒体查询内生效，不影响桌面端）；
     顶对齐 + padding-top 预留固定导航栏（手机端高 60px） */
  .module-hero .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding-top: 76px;
  }

  /* 产品介绍文字：进入文档流排最上（顶部居中通栏，桌面为左下对齐） */
  .hero-desc {
    order: 1;
    position: static;
    width: auto;
    padding: 0 10%;
    box-sizing: border-box;
    text-align: center;
  }

  .hero-desc .hero-title {        /* 主标题 */
    font-size: 5.87vw;
    margin-bottom: 1vh;
  }

  .hero-desc .hero-subtitle {     /* 副标题 */
    font-size: 6.93vw;
    margin-bottom: 2vh;
  }

  .hero-desc .hero-text {         /* 介绍正文（自然换行，\n 由 mobileText 去掉） */
    font-size: 3.47vw;
    line-height: 1.6;
    text-align: justify;
    white-space: normal;
  }

  :lang(en) .hero-desc .hero-title {    /* 主标题（英文单独调节字号） */
    font-size: 5vw;
  }

  :lang(en) .hero-desc .hero-subtitle { /* 副标题（英文单独调节字号） */
    font-size: 4.1vw;
  }

  :lang(en) .hero-desc .hero-text {     /* 介绍正文（英文单独调节字号） */
    font-size: 3vw;
    line-height: 1.5;
  }

  /* wifi图：进入文档流排在文字下方居中（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-hero-wifi {
    order: 2;
    position: static;
    transform: none;
    width: auto;
    height: auto;
    max-width: 26%;
    max-height: 12vh;
    margin: 5vh 0 0 0;
  }

  /* 手机图：进入文档流排最底部居中（改 max-width 调宽、max-height 调高上限） */
  .section-overlay-hero-phone {
    order: 3;
    position: static;
    transform: none;
    width: auto;
    height: auto;
    max-width: 34%;
    max-height: 26vh;
    margin: 2vh 0 0 0;
  }

  /* ---------- 模块二：产品特点 ---------- */

  /* 五个灰块：固定宽绝对定位矩阵改通栏纵向文档流堆叠；
     顶对齐 + padding-top 预留固定导航栏（改 gap 调块间距） */
  .feature-grid {
    position: static;
    transform: none;
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 2vh;
    padding: 80px 6% 2vh;
    box-sizing: border-box;
  }

  /* 灰块公共基础：绝对定位改静态流式卡片，高度随文字内容自适应，
     min-height 保证各手机最低等高（文字换行少的宽屏不会把卡压扁），
     右侧留 42% 给块内图（改每块自己的 padding/width/min-height 单独调） */
  .painless-card,
  .bluetooth-card,
  .calib-card,
  .compact-card,
  .report-card {
    position: static;
    width: 100%;
    height: auto;
    min-height: 14vh;
    max-height: 18vh;
    padding: 2vh 42% 2vh 16px;
  }

  /* 标题：字号缩小（改 font-size 可调） */
  .painless-card .painless-title,
  .bluetooth-card .bluetooth-title,
  .calib-card .calib-title,
  .compact-card .compact-title,
  .report-card .report-title {
    font-size: 4.27vw;
    margin-bottom: 1vh;
  }

  /* 描述：字号缩小；换行由语言包中的 | 单独控制（mobileText 转成真换行，
     pre-line 使其生效），超出宽度的部分仍自然换行 */
  .painless-card .painless-desc,
  .bluetooth-card .bluetooth-desc,
  .calib-card .calib-desc,
  .compact-card .compact-desc,
  .report-card .report-desc {
    font-size: 3.2vw;
    white-space: pre-line;
  }

  /* 英文字号单独调入口（需覆盖桌面 :lang(en) 规则，只改数值即可） */
  :lang(en) .painless-card .painless-title,
  :lang(en) .bluetooth-card .bluetooth-title,
  :lang(en) .calib-card .calib-title,
  :lang(en) .compact-card .compact-title,
  :lang(en) .report-card .report-title {
    font-size: 3.6vw;
  }

  :lang(en) .painless-card .painless-desc,
  :lang(en) .bluetooth-card .bluetooth-desc,
  :lang(en) .calib-card .calib-desc,
  :lang(en) .compact-card .compact-desc,
  :lang(en) .report-card .report-desc {
    font-size: 2.93vw;
  }

  /* 块内图公共基础：保留卡内绝对定位压在文字下层，锚点改右侧垂直居中；
     块高为 auto 时百分比高度不生效，改用 vh 定高（矮屏自动收紧防裁切） */
  .painless-card .painless-img,
  .bluetooth-card .bluetooth-img,
  .calib-card .calib-img,
  .compact-card .compact-img,
  .report-card .report-img {
    top: 50%;
    bottom: auto;
    left: auto;
    transform: translateY(-50%);
    width: auto;
  }

  /* 块内图大小独立调节点：改每图自己的 height 调大小（数值越大图越大），
     改 right 调横向位置（数值越小越靠右） */
  .painless-card .painless-img {   /* 无痛佩戴人物图 */
    right: 3%;
    transform: translateY(-30%);
    height: 30vh;
  }

  .bluetooth-card .bluetooth-img { /* 蓝牙图标 */
    right: 5%;
    height: 10vh;
  }

  .calib-card .calib-img {         /* 无需校准产品图 */
    right: 5%;
    transform: translateY(-34%);
    height: 16vh;
  }

  .compact-card .compact-img {     /* 小巧便携产品图 */
    right: 1%;
    height: 12vh;
  }

  .report-card .report-img {       /* 数据报告图谱图 */
    right: 1%;
    height: 12vh;
  }

  /* ---------- 模块三：应用场景 ---------- */

  /* 标题区：字号缩小、间距收紧改 vh（改 font-size/margin 可调） */
  .module-compact .section-title {
    font-size: 5.87vw;
    line-height: 1.4;
    margin: 0 0 1vh 0;
  }

  .module-compact .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-compact .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 3vh 0;
  }

  /* 白块容器：改 2×2 网格铺满手机宽度（改 grid-template-columns 调列数，改 gap 调块间距） */
  .scene-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2vh;
    width: 88%;
    margin-top: 0;
  }

  /* 白块：宽高改为跟随网格自适应（改 aspect-ratio 调块的高矮比例，改 border-radius 调圆角） */
  .scene-grid .scene-block {
    width: auto;
    height: auto;
    aspect-ratio: 330 / 498;
    border-radius: 12px;
    padding: 10px 10px 0 0;
  }

  /* 块内标题：字号缩小，去掉桌面左右偏移（桌面 margin-left 负值是为了对齐设计稿，手机上归零） */
  .scene-grid .scene-block-title {
    font-size: 3.47vw;
    margin-top: 4px;
    margin-left: 0;
  }

  /* 块内场景图：跟随块宽度缩放（改 width 调大小，改 margin 调与标题的间距） */
  .scene-grid .scene-block-img {
    width: 86%;
    margin: 10px auto 0;
    transform: translateX(4px);
  }

  /* 英文字号单独调入口（中文不显示可忽略；需要时改数值） */
  :lang(en) .module-compact .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-compact .section-subtitle {
    font-size: 3.2vw;
  }

  :lang(en) .scene-grid .scene-block-title {
    font-size: 3.2vw;
  }

  /* ---------- 模块四：控糖打卡 ---------- */

  /* 标题区：字号缩小、间距收紧改 vh（改 font-size/margin 可调） */
  .module-record .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-record .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-record .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 2vh 0;
  }

  /* 手机端专用图（桌面两张图由模板 v-if 停止加载）：宽度百分比 + max-height 兜底，
     超出时 object-fit: contain 保比例（改 width/max-height 调大小） */
  .module-record .record-mobile-img {
    width: 88%;
    height: auto;
    max-height: 70vh;
    object-fit: contain;
    /* 隐藏态：入场位移基准（可见态由下方配对规则归位，过渡只写在可见态） */
    opacity: 0;
    transform: translateY(48px);
  }

  /* 入场动效：与桌面主图同节奏，延迟 0.2s 错开标题区入场 */
  .module-record.is-visible .record-mobile-img {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.8s ease 0.2s,
      transform 0.8s ease 0.2s;
  }

  :lang(en) .module-record .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-record .section-subtitle {
    font-size: 3.2vw;
  }

  /* ---------- 模块五：AGP报告 ---------- */

  /* 整体布局：顶对齐，顶部留白预留固定导航栏（改 padding-top 调标题区上下位置） */
  .module-scene .agp-layout {
    padding-top: 76px;
  }

  /* 标题区：字号缩小、间距收紧改 vh */
  .module-scene .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-scene .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-scene .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 3vh 0;
  }

  /* 底部区：左文右图改上下堆叠文档流（文字在上、AGP图在下，改 gap 调图文间距） */
  .module-scene .agp-body {
    flex-direction: column;
    gap: 3vh;
  }

  /* 文字区：取消固定宽，两侧留白用 %（改 padding 调宽窄） */
  .module-scene .agp-text {
    width: auto;
    align-self: stretch;
    padding: 0 5% 0 4%;
  }

  /* 正文容器：去掉桌面左右边距 */
  .module-scene .agp-points {
    margin: 0;
  }

  /* 每个正文条目：段间距收紧改 vh（改 margin-bottom 调段间距） */
  .module-scene .agp-point {
    gap: 10px;
    margin-bottom: 3vh;
  }

  .module-scene .agp-point:last-child {
    margin-bottom: 2vh;
  }

  /* 图标缩小（改 width/height 调大小） */
  .module-scene .agp-point-icon {
    width: 3vh;
    height: 3vh;
    margin-top: 2px;
  }

  .module-scene .agp-point-text {
    /* 例外：条目是横向 flex（图标+文字），需恢复收缩并允许换行 */
    flex-shrink: 1;
    min-width: 0;
    font-size: 3.73vw;
    line-height: 1.6;
  }

  /* AGP图：桌面固定高 520 + translate(80px, 10px) 偏移手机上溢出，
     改宽度百分比 + max-height 限制，偏移归零（改 width/max-height 调大小） */
  .module-scene .agp-img {
    width: 92%;
    height: auto;
    max-height: 34vh;
    /* 隐藏态：偏移归零叠上入场位移（可见态由下方配对规则归位） */
    transform: translateY(24px);
  }

  /* 动效位移配对覆盖：桌面动效规则带 translate(80px, 10px)，
     手机端隐藏/可见两态都要覆盖，否则入场时位置跳变 */
  .module-scene.is-visible .agp-img {
    transform: translateY(0);
  }

  :lang(en) .module-scene .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-scene .section-subtitle {
    font-size: 3.2vw;
  }

  :lang(en) .module-scene .agp-point-text {
    text-align: justify;
    font-size: 3.2vw;
  }

  /* ---------- 模块六：血糖分析周期回顾 ---------- */

  /* 整体布局：顶对齐，顶部留白预留固定导航栏（改 padding-top 调标题区上下位置） */
  .module-analysis .analysis-layout {
    padding-top: 76px;
  }

  /* 标题区：字号缩小、间距收紧改 vh（桌面小标题左偏移 30px 归零） */
  .module-analysis .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-analysis .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-analysis .section-subtitle {
    font-size: 3.73vw;
    margin: 0 0 0.2vh 0;
  }

  /* 底部区：左图右文改上下堆叠文档流（报告图在上、文字在下，改 gap 调图文间距） */
  .module-analysis .analysis-body {
    flex-direction: column;
    gap: 1vh;
  }

  /* 报告图：桌面固定高 730 + translate(-110px,-95px) 偏移手机上溢出，
     改宽度百分比 + max-height 限制（改 width/max-height 调大小） */
  .module-analysis .analysis-report-img {
    width: 76%;
    height: auto;
    max-height: 80vh;

    /* 隐藏态：偏移归零叠上入场位移（可见态由下方配对规则归位） */
    transform: translateY(24px);
  }

  /* 文字区：取消固定宽与桌面偏移，两侧留白用 %（改 padding 调宽窄） */
  .module-analysis .analysis-text {
    width: auto;
    align-self: stretch;
    padding: 0 6%;
    transform: none;
  }

  .module-analysis .analysis-expert-title {
    font-size: 4.27vw;
    margin: 0 0 8px 0;
    transform: none;
  }

  .module-analysis .analysis-points {
    margin: 0;
    transform: none;
  }

  .module-analysis .analysis-point {
    font-size: 3.2vw;
    margin: 0 0 0.5vh 0;
    padding-left: 14px;
  }

  .module-analysis .analysis-point::before {
    width: 6px;
    height: 6px;
    top: 5px;
  }

  /* 血糖图：右下角绝对定位改文档流排在文字区下方居中（改 width/max-height 调大小）；
     动效入场位移（translateY）直接沿用桌面规则，无需配对覆盖 */
  .module-analysis .analysis-glu-img {
    position: static;
    width: 92%;
    height: auto;
    max-height: 20vh;
    margin-top: 1vh;
  }

  /* 动效位移配对覆盖：桌面动效规则带布局偏移，手机端隐藏/可见两态都要覆盖，否则入场时位置跳变 */
  .module-analysis.is-visible .analysis-report-img {
    transform: translateY(0);
  }

  :lang(en) .module-analysis .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-analysis .section-divider {
    width: 200px;
    margin: 0 auto 3vh;
  }

  :lang(en) .module-analysis .section-subtitle {
    font-size: 3.2vw;
  }

  /* ---------- 模块七：三大模式 ---------- */

  /* 整体布局：顶对齐，顶部留白预留固定导航栏（改 padding-top 调标题区上下位置） */
  .module-model .model-layout {
    padding-top: 76px;
  }

  /* 标题区：字号缩小、间距收紧改 vh */
  .module-model .section-title {
    font-size: 5.87vw;
    margin: 0 0 1vh 0;
  }

  .module-model .section-divider {
    width: 200px;
    margin: 0 auto 2vh;
  }

  .module-model .section-subtitle {
    font-size: 3.73vw;
    margin: 0 12vh 3vh 12vh;
    text-align: center;
  }

  /* 三个卡片：桌面 320×560 固定尺寸手机上放不下，改百分比宽 + 原比例，
     倒三角布局：前两张一排、第三张换行居中（改 width 调卡片宽，改 gap 调卡片间距） */
  .module-model .model-cards {
    flex-wrap: wrap;
    justify-content: center;
    gap: 2vh;
  }

  .module-model .model-card {
    width: 36%;
    height: auto;
    aspect-ratio: 320 / 560;
  }

  /* 遮罩层：内边距与字号缩小（手机端点按卡片触发显示） */
  .module-model .model-card-overlay {
    padding: 10px;
  }

  .module-model .overlay-title {
    font-size: 3.2vw;
    margin: 0 0 6px 0;
  }

  .module-model .overlay-title::after {
    width: 40px;
    margin-top: 6px;
  }

  .module-model .overlay-desc {
    font-size: 2.67vw;
    line-height: 1.4;
  }

  :lang(en) .module-model .section-title {
    font-size: 5.33vw;
  }

  :lang(en) .module-model .section-subtitle {
    font-size: 3.2vw;
  }

  :lang(en) .module-model .overlay-title {
    font-size: 2.8vw;
  }

  :lang(en) .module-model .overlay-desc {
    font-size: 2.2vw;
  }

  /* ---------- 模块八：官方商城（英文下整体隐藏，无需 :lang(en) 覆盖） ---------- */

  /* 大标题：字号缩小，桌面上移 70px 偏移手机归零，位置由容器顶对齐接管 */
  .module-shop .section-title {
    font-size: 7vw;
    transform: none;
    margin-top: 25vh;
  }

  /* 三个商城入口：手机端改竖向堆叠，整体居中（改 gap 调间距，改 margin-top 调与标题的距离） */
  .shop-links {
    flex-direction: column;
    align-items: center;
    gap: 8vh;
    margin-top: -12vh;
  }

  .shop-link {
    gap: 1vh;
  }

  /* 图标缩小（改 width/height 调大小） */
  .shop-link img {
    width: 8vh;
    height: 8vh;
  }

  .shop-link span {
    font-size: 3.47vw;
  }

  .shop-link span::after {
    font-size: 5vw;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>

<!-- 产品页透明导航栏样式（Header 已提升到 App.vue，此处用全局样式控制） -->
<style>
/* 导航栏背景过渡：模块一透明 ↔ 其他模块白底平滑切换 */
.header {
  transition: background-color 0.3s ease;
}

/* 仅产品页模块一可见时导航栏透明 */
.header.header-transparent {
  background: transparent;
}

/* 透明状态下导航栏文字变白（选中态/hover 的青色保持不变） */
.header.header-transparent .nav-item,
.header.header-transparent .lang-text {
  color: #FFFFFF;
}
</style>
